<!--Spinner-->
<div class="d-flex justify-content-center">
  <div
    class="spinner-border"
    role="status"
    [ngStyle]="{
      display: loadedImg == countImg && loadedImg !== 0 ? 'none' : ''
    }"
  >
    <span class="sr-only">Loading...</span>
  </div>
</div>
<!--Carousel-->
<div
  id="carouselExampleIndicators"
  class="carousel slide"
  data-ride="carousel"
  [ngStyle]="{
    display: loadedImg == countImg && loadedImg !== 0 ? '' : 'none'
  }"
>
  <div>
    <div class="carousel-inner">
      <div
        *ngFor="let image of gallery; let i = index"
        class="carousel-item"
        [ngClass]="
          i === currentImg ? 'active d-flex justify-content-center' : ''
        "
      >
        <img
          [src]="image"
          (load)="loadedImg = loadedImg + 1"
          class="d-block size-img"
          alt="..."
        />
      </div>
    </div>
    <a
      *ngIf="countImg > 1"
      class="carousel-control-prev"
      (click)="changeImg(-1)"
      role="button"
      data-slide="prev"
    >
      <!-- <span class="carousel-control-prev-icon" aria-hidden="true"></span> -->
      <i class="fa fa-chevron-left arrow-color" aria-hidden="true"></i>
      <span class="sr-only">Previous</span>
    </a>
    <a
      *ngIf="countImg > 1"
      class="carousel-control-next"
      (click)="changeImg(1)"
      role="button"
      data-slide="next"
    >
      <i class="fa fa-chevron-right arrow-color" aria-hidden="true"></i>
      <span class="sr-only">Next</span>
    </a>
  </div>
  <div class="m-2 display-flex justify-center align-center buttons">
    <button
      *ngFor="let item of gallery; let i = index"
      class="button button-line"
      [ngClass]="{ active: currentImg === i }"
    ></button>
  </div>
</div>
